import e, { useState as c, useRef as x, useMemo as K, useEffect as C, useCallback as Q } from "react";
import t from "./index213.mjs";
import { RoomDetailsTags as X } from "./index214.mjs";
import { IconType as g } from "./index196.mjs";
import { Rates as M } from "./index215.mjs";
import { ImageSlider as ee } from "./index216.mjs";
import { RoomTitle as te } from "./index217.mjs";
import I from "classnames";
import { IPAD_AIR_WIDTH as ne } from "./index17.mjs";
import { ImageGallery as oe } from "./index218.mjs";
import { useMediaWatcher as re } from "./index219.mjs";
import { formatPrice as ae } from "./index110.mjs";
import le from "./index179.mjs";
import se from "./index180.mjs";
import ie from "./index79.mjs";
import { getConfigPropertyAtomCreator as me, ConfigProperty as ce, ViewLayout as ue } from "./index13.mjs";
import { useAtomValue as pe } from "jotai";
const _e = (o) => {
  var a;
  return o.reduce(
    (r, n) => {
      let l = r;
      return Number(n.total_price) < Number(r.totalPrice) && (l = { totalPrice: n.total_price, isPromotion: !1 }), n.promotions && (l = n.promotions.reduce((m, i) => Number(i.total_price) < Number(m.totalPrice) ? { totalPrice: i.total_price, isPromotion: !0 } : m, l)), l;
    },
    { totalPrice: ((a = o[0]) == null ? void 0 : a.total_price) ?? "0", isPromotion: !1 }
  );
}, ge = ({
  lowestRate: o,
  currency: a,
  showRates: r,
  onToggle: n
}) => /* @__PURE__ */ e.createElement(
  "button",
  {
    type: "button",
    className: t.rate_toggle,
    onClick: n,
    "aria-expanded": r,
    "aria-label": r ? I18n.t("booking_engine.results.hide_rates") : I18n.t("booking_engine.results.show_and_select_rates")
  },
  /* @__PURE__ */ e.createElement("div", { className: t.price_info }, /* @__PURE__ */ e.createElement("span", { className: t.from_label }, I18n.t("booking_engine.results.rate.from"), " "), /* @__PURE__ */ e.createElement("span", { className: t.price }, ae(Number(o), a, !0))),
  /* @__PURE__ */ e.createElement("div", { className: t.toggle_button }, r ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", null, I18n.t("booking_engine.results.hide_rates")), /* @__PURE__ */ e.createElement(le, null)) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", null, I18n.t("booking_engine.results.show_and_select_rates")), /* @__PURE__ */ e.createElement(se, null)))
), Fe = ({
  id: o,
  images: a,
  name: r,
  size: n,
  beds: l,
  maxOccupancy: m,
  description: i,
  rates: f,
  currency: d,
  roomType: N,
  motherName: E,
  noOfRooms: v,
  isExpanded: V,
  motherId: y,
  merchantId: R,
  cityTaxIncluded: k = !1,
  onRateSelect: h
}) => {
  const { isBelowBreakpoint: P, hasEvaluatedView: B } = re(ne), [u, L] = c(!1), [H, S] = c(!1), [A, D] = c(!1), [U, $] = c(!0), [F, O] = c([]), b = x(null), W = x(null), z = pe(
    K(() => me(ce.VIEW_LAYOUT), [])
  ) === ue.FULL_SCREEN, G = _e(f);
  C(() => {
    ie.getRoomAmenities(o).then((s) => {
      O(s.amenities.filter(Boolean));
    });
  }, [o]), C(() => {
    const s = () => {
      if (b.current) {
        const p = b.current, w = p.scrollHeight > p.clientHeight + 5;
        $(w);
      }
    }, T = setTimeout(s, 100);
    return window.addEventListener("resize", s), () => {
      clearTimeout(T), window.removeEventListener("resize", s);
    };
  }, [i]);
  const Y = () => {
    u ? (S(!1), setTimeout(() => L(!1), 300)) : (L(!0), setTimeout(() => S(!0), 50));
  }, Z = Q(() => {
    const s = {
      iconType: g.SIZE,
      label: `${n} m²`
    }, T = l.map((_) => ({
      iconType: g.DOUBLE_BED,
      label: `${_.amount} ${I18n.t(
        `booking_engine.results.bed_size.${_.bed_type}`
      )}`
    })), p = {
      iconType: g.GUESTS,
      label: `${m} max.`
    }, w = {
      iconType: g.PROPERTY,
      label: I18n.t("booking_engine.results.whole_property")
    }, J = F.map((_) => ({
      label: _
    }));
    return [
      ...N == "cottage" ? [w] : [],
      ...n ? [s] : [],
      ...T,
      p,
      ...J
    ];
  }, [n, l, m, N, F]);
  if (!B)
    return null;
  const j = () => /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    ge,
    {
      lowestRate: G.totalPrice,
      currency: d,
      showRates: u,
      onToggle: Y
    }
  ), /* @__PURE__ */ e.createElement(
    "div",
    {
      className: I(t.rates_container, {
        [t.visible]: u,
        [t.animated]: H
      }),
      ref: W
    },
    u ? /* @__PURE__ */ e.createElement(
      M,
      {
        rates: f,
        currency: d,
        roomId: o,
        merchantId: R,
        motherId: y,
        motherName: E,
        noOfRooms: v,
        cityTaxIncluded: k,
        onRateSelect: h
      }
    ) : null
  )), q = () => /* @__PURE__ */ e.createElement(
    M,
    {
      rates: f,
      currency: d,
      roomId: o,
      merchantId: R,
      motherId: y,
      motherName: E,
      noOfRooms: v,
      cityTaxIncluded: k,
      onRateSelect: h
    }
  );
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "room-tile",
      className: I(t.container, {
        [t.expanded]: V,
        [t.container_fullscreen]: z
      })
    },
    /* @__PURE__ */ e.createElement("div", { className: t.room_details_container }, /* @__PURE__ */ e.createElement("div", { className: t.image_slider_container }, P ? /* @__PURE__ */ e.createElement(ee, { images: a, source: "results_page" }) : /* @__PURE__ */ e.createElement(oe, { images: a })), /* @__PURE__ */ e.createElement("div", { className: t.room_details }, /* @__PURE__ */ e.createElement(te, { name: r, motherName: E }), /* @__PURE__ */ e.createElement(X, { tags: Z(), scrollable: !0 }), /* @__PURE__ */ e.createElement(
      "div",
      {
        className: I(t.room_description, {
          [t.expanded_description]: A
        })
      },
      A ? /* @__PURE__ */ e.createElement("div", { className: t.description_text }, /* @__PURE__ */ e.createElement("span", { dangerouslySetInnerHTML: { __html: i } }), /* @__PURE__ */ e.createElement(
        "button",
        {
          type: "button",
          className: t.show_less_button,
          onClick: () => D(!1),
          "aria-label": I18n.t(
            "booking_engine.accessibility.collapse_section"
          )
        },
        I18n.t("booking_engine.results.read_less")
      )) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
        "span",
        {
          className: t.description_text,
          ref: b,
          dangerouslySetInnerHTML: { __html: i }
        }
      ), U ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("span", { className: t.ellipsis, "aria-hidden": "true" }, "[...]"), /* @__PURE__ */ e.createElement(
        "button",
        {
          type: "button",
          className: t.show_more_button,
          onClick: () => D(!0),
          "aria-label": I18n.t(
            "booking_engine.accessibility.expand_section"
          )
        },
        I18n.t("booking_engine.results.read_more")
      )) : null)
    ))),
    P ? j() : q()
  );
};
export {
  Fe as RoomTile
};
